import React from 'react'

export function renderSelectOptionsList(kvpList) {
    return kvpList.map((kvp) => {
        return (<option key={kvp.Key} value={kvp.Key}>{kvp.Value}</option>);
    });
}
export function renderSelectOptions(dictionary) {
    return Object.keys(dictionary).map((key) => {
        return (<option key={key} value={key}>{dictionary[key]}</option>);
    });
}

export function objectToFormData(obj, form, namespace) {
    var fd = form || new FormData();
    var formKey;

    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {

            if (namespace) {
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File, iterate recursively
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, property);
            } else {
                fd.append(formKey, obj[property]);
            }

        }
    }

    return fd;
}

/*
 * For MaskedInput third-party plugin. 
 *  Checks to see if the value has the masked characters
 *  Default mask character == '_'
 */
export function IsMaskedInputValidated(value, maskchar) {
    maskchar = maskchar == null ? '_' : maskchar;
    if (value == null) { return false; }
    return (value.indexOf(maskchar) < 0);
}

/*
 * Builds a temporary form to submit a post request and redirect to the url provided
 */
export function PostRedirect(url, parameters) {
    var form = document.createElement("FORM");
    form.method = "POST";
    form.action = url;
    for (var key in parameters) {
        var input = document.createElement('INPUT');
        input.type = 'HIDDEN';
        input.name = key;
        input.value = parameters[key];
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
}